/** Typed access to build-time environment. Never read import.meta.env elsewhere. */
function parseLatency(raw: string | undefined): [number, number] {
  const [min = '0', max = '0'] = (raw ?? '0,0').split(',');
  const a = Math.max(0, Math.trunc(Number(min)) || 0);
  const b = Math.max(a, Math.trunc(Number(max)) || 0);
  return [a, b];
}

export const env = {
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL) ?? '/api',
  apiMock: import.meta.env.VITE_API_MOCK === 'true',
  /**
   * Readable CSRF cookie set by the API (double-submit). `__Host-dd_csrf` over HTTPS and on http://localhost (a secure
   * context in Chrome and Firefox); `dd_csrf` where the API runs without Secure cookies. When unset the client tries
   * both names.
   */
  csrfCookie: import.meta.env.VITE_CSRF_COOKIE ?? '',
  mockLatency: parseLatency(import.meta.env.VITE_MOCK_LATENCY),
  sentryDsn: (import.meta.env.VITE_SENTRY_DSN) ?? '',
  sentryEnvironment: (import.meta.env.VITE_SENTRY_ENVIRONMENT) ?? 'development',
  release: (import.meta.env.VITE_RELEASE) ?? 'local',
  isDev: import.meta.env.DEV,
  isTest: import.meta.env.MODE === 'test',
} as const;
